<template>
    <h2>{{$t('addPartners')}}</h2>
  </template>
  
  <script>
  export default {
      name: 'ortho-new-partners'
  }
  </script>
  
  <style>
  
  </style>
  